import Image from '@tiptap/extension-image';

const ImageWithSize = Image.extend({
    addAttributes() {
        return {
            ...this.parent?.() || {},
            width: {
                default: null,
                parseHTML: element => element.getAttribute('width'),
                renderHTML: attributes => {
                    if (!attributes.width) {
                        return {};
                    }
                    return {
                        width: attributes.width,
                    };
                },
            },
            height: {
                default: null,
                parseHTML: element => element.getAttribute('height'),
                renderHTML: attributes => {
                    if (!attributes.height) {
                        return {};
                    }
                    return {
                        height: attributes.height,
                    };
                },
            },
            class: {
                default: 'float-none',
                parseHTML: element => element.getAttribute('class') || 'float-none',
                renderHTML: attributes => {
                    return attributes.class ? { class: attributes.class } : {};
                },
            },
            // Légende sémantique : si présente, l'image est wrappée dans un <figure>
            // avec un <figcaption>. Convention markdown : ligne italique seule juste
            // après une image standalone.
            caption: {
                default: null,
                parseHTML: element => {
                    // Si l'image est dans un <figure>, prendre le texte de la <figcaption>
                    const parent = element.parentElement;
                    if (parent && parent.tagName === 'FIGURE') {
                        const cap = parent.querySelector('figcaption');
                        return cap ? cap.textContent : null;
                    }
                    return element.getAttribute('data-caption');
                },
                // Pas d'attribut HTML sur <img> directement — la caption est rendue
                // dans le <figcaption> via renderHTML ci-dessous.
                renderHTML: () => ({}),
            },
        };
    },

    renderHTML({ node, HTMLAttributes }) {
        // HTMLAttributes contient déjà les attrs sérialisés (src, alt, width, height, class)
        const imgTag = ['img', HTMLAttributes];

        if (node.attrs.caption) {
            return [
                'figure',
                { class: 'article-figure article-figure--image' },
                imgTag,
                ['figcaption', {}, node.attrs.caption],
            ];
        }

        return imgTag;
    },
});

export default ImageWithSize;
